<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
            name="Add Rolling Reserve"
            bc1="App"
            bc2="Rolling Reserve"
            bc3="Add"
            path="rolling-reserve"
          ></Breadcrumb>
        </div>
        <div
          class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >

        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Add Details</h4>
                </div>
                <div class="card-body">
                  <form class="form form-horizontal">
                    <div class="row">
                      <div class="col-12" v-show="showAlert">
                        <div class="form-group row">
                          <div class="col-3"></div>
                          <div class="col-9">
                            <div class="alert alert-danger" role="alert">
                                <h4 class="alert-heading">Alert</h4>
                                            <div class="alert-body">
                                                Avaliable balance in the account is less than the input reserve amount.
                                                The Account balance will be negative if you proceed.
                                            </div>
                                 </div>
                          </div>
                        </div>
                        
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="schema-icon">Schema</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">

                              <SelectOptions label="" :hideLabel="true" :removeFormGroupClass="true"
                                             selectAppend="Schema"
                                             :labelValue="(item) => item?.description? item.name + '/' + item.code + ' (' + item.description + ')' : item.name + '/' + item.code "
                                             :filter="{ status: 'active' }"
                                             :modelValue.sync="selectedSchema" url="v1/get-schema"/>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Select Merchant</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                                    <multiselect
                                        v-model="selectedMerchant"
                                        :options="MerchantsData"
                                        label="label"
                                        track-by="id"
                                        placeholder="Select Merchant"
                                        variant="primary"
                                        :custom-label="customNameForMultiselect"
                                    ></multiselect>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Select Account</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <select
                                  class="form-control"
                                  v-model="selectedMerchantDetails"
                              >
                                <option
                                    :key="merchantDetailsIndex"
                                    :value="merchantDetails"
                                    v-for="(merchantDetails, merchantDetailsIndex) in MerchantDetailsData"
                                >
                                  {{ merchantDetails.account_title + ' / ' + merchantDetails.currency.code }}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Select Channel</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <multiselect
                                  v-model="selectedChannel"
                                  :options="channelData"
                                  label="label"
                                  track-by="id"
                                  placeholder="Select Channel"
                                  :loading="channelLoader"
                                  variant="primary"
                                  :custom-label="customStoreNameForMultiselect"
                              ></multiselect>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="acquirng-icon">Acquirings</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                          
                              <SelectOptions label="" :hideLabel="true" :removeFormGroupClass="true" selectAppend="Acquirings" labelValue="name" :filter="{ status: 'active' }"
                                :modelValue.sync="selectedAcquiring" url="v1/get-aquiring" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="amount-icon">Reserve Amount</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                          
                              <input
                                type="number"
                                v-model="reserveAmount"
                                id="amount-icon"
                                class="form-control"
                                :class="
                                  errorBag.has('reserveAmount') ? 'is-invalid' : ''
                                "
                                name="reserveAmount"
                                placeholder="Amount"
                                v-validate="'required|greaterThanZero'"
                              />
                              <small
                                v-show="errorBag.has('reserveAmount')"
                                class="invalid-feedback"
                                >{{ "*" + errorBag.first("reserveAmount") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="referenceId-icon">Reference ID</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                          
                              <input
                                type="text"
                                v-model="referenceId"
                                id="referenceId-icon"
                                class="form-control"
                                :class="
                                  errorBag.has('referenceId') ? 'is-invalid' : ''
                                "
                                name="referenceId"
                                placeholder="Reference ID"
                                v-validate="'required'"
                              />
                              <small
                                v-show="errorBag.has('referenceId')"
                                class="invalid-feedback"
                                >{{ "*" + errorBag.first("referenceId") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="comment-icon">Comments</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">

                                <textarea
                                  v-model="comments"
                                  id="comment-icon"
                                  class="form-control"
                                  name="comments"
                                  placeholder="Type comments here ..."
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label mt-1">
                            <label for="duration-icon">Duration</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="">
                              <div class="demo-inline-spacing d-flex justify-content-center">
                                  <div class="text-center mt-0">
                                    <label>Days</label>
                                    <SpinBtn v-model="duration.days" />
                                  </div>
                                  <div class="text-center mt-0">
                                    <label>Hours</label>
                                    <SpinBtn v-model="duration.hours" :max="23" />
                                  </div>
                                  <div class="text-center mt-0">
                                    <label>Mins</label>
                                    <SpinBtn v-model="duration.mins" :max="59" />
                                  </div>
        
                                </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-9 offset-sm-3 d-flex mt-2">
                        <button
                          type="button"
                          class="btn btn-primary mr-1 d-flex"
                          @click="sendCall"
                          :disabled="loading"
                        >
                          <Loader :loading="loading" :size="size"></Loader>
                          Create
                        </button>
                        <button
                          type="button"
                          class="btn btn-gradient-secondary"
                          @click="$router.back()"
                        >
                          Back
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import { TargetIcon, Edit3Icon, CommandIcon } from "vue-feather-icons";
import SpinBtn from "../../../components/common/SpinBtn.vue";
export default {
  components: {
    TargetIcon,
    Edit3Icon,
    CommandIcon,
    SpinBtn
  },
  created() {
  this.$validator.extend(
  'greaterThanZero',{
   getMessage: field =>  field + ' must be greater than 0.',
   validate: (value) => {
     // value must be > zero
     if (value > 0 ) return true;
     return false;
   }
  });
},
  mounted() {
    this.getMerchantData()
  },
  data() {
    return {
      name: "",
      symbol: "",
      logo: null,
      type: "",
      exchangeFrom: "",
      rate: "",
      code: "",
      loading: false,
      size: "10px",
      duration: {
        days: 0,
        hours: 0,
        mins: 0,
      },
      selectedMerchant: null,
      selectedChannel: null,
      MerchantsData: [],
      channelData: [],
      channelLoader:false,
      MerchantDetailsData: [],
      selectedMerchantDetails: null,
      selectedAcquiring: null,
      selectedSchema: null,
      reserveAmount:0,
      referenceId:'',
      comments:'',
      showAlert:false
      
    };
  },
  methods: {
    getChannelData() {
      this.channelLoader = true
      this.makeRequest("post", "v1/get-channel", {userId: this.selectedMerchant.id,status:1}, {}, false,true,[205]).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                if(responseData){
                  this.channelData = responseData;
                }
                else{
                  this.channelData = []
                }
                this.setSelectedChannelValue();
              }
            }
            this.channelLoader = false
          }
      );
    },
    setSelectedChannelValue() {
      if (this.selectedChannel == null && this.channelData.length > 0) {
        this.selectedChannel = this.channelData[0];

      }
      else{
        this.selectedChannel = null
      }
    },
    getMerchantData() {
      this.makeRequest("post", "v1/get-merchants", {flag: 'all'}, {}, false,true,[205]).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                this.MerchantsData = responseData;
                this.setSelectedMerchantValue();
              }
            }
          }
      );
    },
    setSelectedMerchantValue() {


      if (this.selectedMerchant == null && this.MerchantsData.length > 0) {
        this.selectedMerchant = this.MerchantsData[0];
      }
    },
    getMerchantDetailsData(id) {
      this.makeRequest("post", "v1/detail-merchant", {id: id}, {}, false,true,[205]).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                this.MerchantDetailsData = responseData.accounts ? responseData.accounts : [];
                this.setSelectedMerchantDetailsValue();
              }
            }
          }
      );
    },
    setSelectedMerchantDetailsValue() {

      this.selectedMerchantDetails = this.MerchantDetailsData[0];
    },
    customNameForMultiselect ({ email,first_name }) {
      return `${email}/${first_name}`
    },
    customStoreNameForMultiselect ({ name,code }) {
      return `${name}/${code}`
    },
    sendCall() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;
          let durationInMinutes = (this.duration.days * 24 * 60) + (this.duration.hours * 60) + (this.duration.mins)
          let data = {
            comments:this.comments,
            channelId: this.selectedChannel?.id,
              schemaId: this.selectedSchema?.id,
              acquiringId : this.selectedAcquiring?.id,
              referenceId: this.referenceId,
              userAccountId:this.selectedMerchantDetails?.id,
              reserveAmount: this.reserveAmount*100,
            duration: durationInMinutes

          }
          // console.log(data,222222)

          // return
        
          this.makeRequest("post", "v1/create-rolling-reserve", data).then(
            callResponse => {
              if (!callResponse.error) {
                let code = callResponse.response.data.code;
                if (code == 200) {
                  this.loading = false;
                  this.$router.back()
                }
              }
              this.loading = false;
            }
          );
        }
      });
    }
  },
  watch:{
    reserveAmount(val)
    {
      if(this.selectedMerchantDetails){
        if(val > this.selectedMerchantDetails?.available_balance/100){
          this.showAlert = true
          return
        }
      }
      this.showAlert = false
    },
    selectedMerchantDetails(val)
    {
      if(this.reserveAmount > val.available_balance/100 ){
        this.showAlert = true
      }else{
        this.showAlert = false
      }
    },
    selectedMerchant(val) {
      if(val){
        this.getMerchantDetailsData(val.id)
        this.getChannelData()
      }
    },
    
  }
};
</script>

